(() => {
  const emit = (event, values = {}) => {
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...values });
  };
  document.querySelectorAll('[data-gift-finder]').forEach(root => {
    let screen = 'who';
    const answers = {};
    const templates = key => root.querySelector(`template[data-gift-card="${key}"]`);
    const show = next => {
      screen = next;
      root.querySelectorAll('[data-gift-screen]').forEach(el => { el.hidden = el.dataset.giftScreen !== next; });
      root.querySelector('[data-gift-back]').disabled = next === 'who';
      const step = next === 'who' ? 1 : next === 'kind' ? 2 : 3;
      root.querySelector('[data-gift-progress]').textContent = `${step}/3`;
      root.querySelector('[data-gift-count="1"]').hidden = answers.who === 'family';
      root.querySelector(`[data-gift-screen="${next}"] legend, [data-gift-screen="${next}"] h2`)?.focus();
    };
    root.querySelectorAll('[data-count-price]').forEach(el => {
      el.textContent = templates(`bracelet-${el.dataset.countPrice}`).dataset.price;
    });
    const result = () => {
      const kind = answers.who === 'two' ? 'pair' : answers.who === 'family' || answers.kind === 'bracelet' ? 'bracelet' : 'necklace';
      const count = kind === 'bracelet' ? answers.count || '2' : '1';
      const top = root.querySelector('[data-gift-top]');
      const alts = root.querySelector('[data-gift-alts]');
      top.replaceChildren(templates(`${kind}-${count}`).content.cloneNode(true));
      alts.replaceChildren();
      ['necklace', 'bracelet', 'pair'].filter(item => item !== kind).forEach(item => {
        const n = item === 'bracelet' && kind === 'pair' ? '2' : '1';
        const template = templates(`${item}-${n}`);
        const card = template.content.cloneNode(true);
        card.querySelector('[data-gift-reason]')?.remove();
        if (item === 'bracelet' && kind !== 'pair' && card.querySelector('[data-gift-price]')) card.querySelector('[data-gift-price]').textContent = template.dataset.from;
        alts.append(card);
      });
      show('result');
      emit('gift_finder_complete', { product: kind });
    };
    // Click also allows a retained radio answer to advance again after Back.
    root.addEventListener('click', event => {
      const radio = event.target.closest('input[type="radio"]');
      if (radio) {
        answers[screen] = radio.value;
        emit('gift_finder_step', { step: screen, answer: radio.value });
        if (screen === 'who') {
          if (radio.value === 'two') result();
          else show(radio.value === 'family' ? 'count' : 'kind');
        } else if (screen === 'kind' && radio.value === 'bracelet') show('count');
        else result();
      }
      if (event.target.closest('[data-gift-back]')) show(screen === 'kind' ? 'who' : screen === 'count' ? answers.who === 'family' ? 'who' : 'kind' : answers.who === 'two' ? 'who' : answers.who === 'family' || answers.kind === 'bracelet' ? 'count' : 'kind');
      if (event.target.closest('[data-gift-reset]')) show('who');
      if (event.target.closest('[data-gift-close]')) root.close();
      const link = event.target.closest('[data-gift-result]');
      if (link) emit('gift_finder_result_click', { product: link.dataset.giftResult, rank: link.closest('[data-gift-top]') ? 1 : 2 });
    });
    // Arrow-key radio selection has the same progression as tapping.
    root.addEventListener('keydown', event => {
      if (event.target.matches('input[type="radio"]') && ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
        const radios = [...event.target.closest('fieldset').querySelectorAll('input')].filter(el => !el.closest('label').hidden);
        const direction = ['ArrowUp', 'ArrowLeft'].includes(event.key) ? -1 : 1;
        const next = radios[(radios.indexOf(event.target) + direction + radios.length) % radios.length];
        next.checked = true;
        next.click();
      }
    });
    root.addEventListener('close', () => { document.documentElement.classList.remove('gift-finder-modal-open'); });
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-gift-open]');
    if (!trigger) return;
    const dialog = document.getElementById('gift-finder-dialog');
    if (dialog && !dialog.open) {
      dialog.showModal();
      document.documentElement.classList.add('gift-finder-modal-open');
      emit('gift_finder_open', { entry_point: trigger.dataset.giftOpen });
    }
  });
})();
